import { render, staticRenderFns } from "./DwGoodsList.vue?vue&type=template&id=6bfedd9e&scoped=true"
import script from "./DwGoodsList.vue?vue&type=script&lang=js"
export * from "./DwGoodsList.vue?vue&type=script&lang=js"
import style0 from "./DwGoodsList.vue?vue&type=style&index=0&id=6bfedd9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfedd9e",
  null
  
)

export default component.exports